// Fuzzball Quiz System - Main Entry Point
// Initialize the quiz system when DOM is ready

(function() {
  'use strict';
  
  // Wait for DOM and all scripts to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
  
  function initQuiz() {
    
    // Only initialize if we're on a page with the quiz container
    const quizContainer = document.querySelector('.fuzzball-quiz-container');
    if (!quizContainer) {
      return;
    }
    
    // Check for edit mode early to prevent visual flash
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('mode') === 'edit') {
      document.body.classList.add('edit-mode');
    } 
    
    // Initialize the main quiz controller
    if (typeof QuizController !== 'undefined') {
      window.fuzzballQuiz = new QuizController();
    } else {
    }
  }
})();